import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "sub-status subscription-expired"
}
const _hoisted_2 = {
  key: 1,
  class: "sub-status"
}
const _hoisted_3 = {
  key: 2,
  class: "sub-status"
}
const _hoisted_4 = {
  key: 0,
  class: "sub-status"
}
const _hoisted_5 = { class: "sub-status" }
const _hoisted_6 = {
  key: 0,
  class: "sub-status"
}
const _hoisted_7 = { class: "sub-status" }
const _hoisted_8 = {
  key: 6,
  class: "sub-status"
}
const _hoisted_9 = {
  key: 7,
  class: "sub-status"
}

import { computed } from 'vue';
import i18n from '@/i18n/index';
import { SubscriptionMember } from "@/interfaces/subscriptionMember";


export default /*#__PURE__*/_defineComponent({
  __name: 'statusSubscription',
  props: {
    subscription: {}
  },
  setup(__props: any) {

const props = __props;

const sub = computed(() => props.subscription);
const status = computed(() => sub.value?.status ?? null);

const isSession = computed(() => sub.value?.status?.type === 'session');
const isPoints = computed(() => sub.value?.status?.type === 'points');
const isCaneclled = computed(() => (sub.value?.status?.type === 'canceled' || sub.value?.status?.type === 'transfer'));
//const isMonthly = computed(() => sub.value?.status?.type === 'monthly');

const remainingDays = computed(() => (status.value?.remaining_days && status.value?.remaining_days > 0) ? status.value?.remaining_days : 0);
const daysToStart = computed(() => status.value?.days_to_start ?? null);
const activePausedDays = computed(() => status.value?.current_pause_days ?? null);
 
const remaining = computed(() =>
    isSession.value
        ? status.value?.remaining_seances ?? 0
        : isPoints.value
            ? status.value?.remaining_points ?? 0
            : 0
);
const limited = computed(() =>
    isSession.value
        ? sub.value?.limited_sessions ?? null
        : isPoints.value
            ? sub.value?.limited_points ?? null
            : null
);
const consumed = computed(() =>
    isSession.value
        ? sub.value?.consumed_sessions ?? 0
        : isPoints.value
            ? sub.value?.consumed_points ?? 0
            : 0
);
const label = computed(() =>
    isSession.value
        ? i18n.t('symbole.seance')
        : isPoints.value
            ? i18n.t('symbole.point')
            : ''
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isCaneclled.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_1, " 0 " + _toDisplayString(_unref(i18n).t('symbole.day')), 1))
      : (status.value?.comment === 'not_started' && daysToStart.value !== null)
        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(daysToStart.value) + " " + _toDisplayString(_unref(i18n).t('symbole.day')), 1))
        : (status.value?.comment === 'paused' && activePausedDays.value !== null)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(activePausedDays.value) + " " + _toDisplayString(_unref(i18n).t('symbole.day')), 1))
          : (remainingDays.value !== null)
            ? (_openBlock(), _createElementBlock("span", {
                key: 3,
                class: _normalizeClass(["sub-status", remainingDays.value <= 0 ? 'subscription-expired' : 'subscription-active'])
              }, _toDisplayString(remainingDays.value) + " " + _toDisplayString(_unref(i18n).t('symbole.day')), 3))
            : _createCommentVNode("", true),
    (isSession.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
          (limited.value !== null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(limited.value) + " " + _toDisplayString(label.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_5, _toDisplayString(consumed.value) + " " + _toDisplayString(label.value) + " consommé ", 1),
          _createElementVNode("span", {
            class: _normalizeClass(["sub-status", remaining.value <= 0 ? 'subscription-expired' : 'subscription-active'])
          }, _toDisplayString(remaining.value) + " " + _toDisplayString(label.value) + " restants ", 3)
        ], 64))
      : _createCommentVNode("", true),
    (isPoints.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
          (limited.value !== null)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(limited.value) + " " + _toDisplayString(label.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_7, _toDisplayString(consumed.value) + " " + _toDisplayString(label.value) + " consommé ", 1),
          _createElementVNode("span", {
            class: _normalizeClass(["sub-status", remaining.value <= 0 ? 'subscription-expired' : 'subscription-active'])
          }, _toDisplayString(remaining.value) + " " + _toDisplayString(label.value) + " restants ", 3)
        ], 64))
      : _createCommentVNode("", true),
    (isCaneclled.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(status.value?.comment  ?? ''), 1))
      : (status.value?.comment)
        ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(i18n).t('comment.' + status.value.comment)), 1))
        : _createCommentVNode("", true)
  ], 64))
}
}

})